module.exports = __webpack_public_path__ + "static/media/16.629df375.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/16.png
// module id = 1454
// module chunks = 0